import styled from 'styled-components';

export const Container = styled.div`
  background: var(--primary);
`;
export const Wrapper = styled.div`
  max-width: 1280px;
  height: 100%;
  margin: 0 auto;

  display: flex;
  justify-content: center;
  
`